/* eslint-disable no-nested-ternary */
import Tooltip from '@mui/material/Tooltip';
import Image from 'components/Image';
import emoji from '/components/emoji';
import { getBadge } from '../../helpers/getBadge';

export default function Badge({ name, type, size }) {
  const badge = getBadge(type, name);

  if (!badge || !badge.name) return <></>;
  return (
    <Tooltip
      disableFocusListener
      disableTouchListener
      title={
        type === 'region' || type === 'country'
          ? `Blogged about ${badge.name}`
          : badge.description || badge.name
      }
    >
      {badge.emoji ? (
        <span style={{ fontSize: size || '2em' }} className="cpointer">
          {emoji(badge.emoji)}
        </span>
      ) : (
        <div className="cpointer p-1 d-inline">
          <Image
            src={`/img/badges/${badge.name}.png`}
            alt={badge.name}
            width={size === '4em' ? 60 : size === '8em' ? 120 : 30}
            height={size === '4em' ? 60 : size === '8em' ? 120 : 30}
          />
        </div>
      )}
    </Tooltip>
  );
}
